import React from 'react';
import { Dispatch } from 'architecture'
import _ from 'lodash'
import DatePicker from 'react-datepicker';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { faTags } from '@fortawesome/free-solid-svg-icons'
import { faCog } from '@fortawesome/free-solid-svg-icons'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { faBan } from '@fortawesome/free-solid-svg-icons'
//import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import Linkify from 'react-linkify'
import DropZone from 'react-dropzone'
import moment from 'moment'

import TagInput from './TagInput/TagInput'
import Auth from './Auth'

import loading from '../media/loading.svg'
import logo from '../media/logo.svg'
import Tag from './TagInput/Tag'

export default (props) => {
  const open = props.Sidebar ? props.Sidebar.open : true
  const tags = props.Tags ? Object.keys(props.Tags)
    .reduce((acc,next) => ({...acc, [next]: {...props.Tags[next], removeable: false, editable: true }}) ,{}) : {}
  const peopleTags = Object.keys(tags)
    .filter(key => tags[key].type === 'user')
    .reduce((acc,next) => ({...acc, [next]: tags[next]}) ,{})
  const typeTags = Object.keys(tags)
    .filter(key => tags[key].type === 'instanceType')
    .reduce((acc,next) => ({...acc, [next]: tags[next]}) ,{})
  const statusTags = Object.keys(tags)
    .filter(key => tags[key].type === 'status')
    .reduce((acc,next) => ({...acc, [next]: tags[next]}) ,{})
  const otherTags = Object.keys(tags)
    .filter(key => tags[key].type === 'other')
    .reduce((acc,next) => ({...acc, [next]: tags[next]}) ,{})

  const onEdit = (tagId) => {
    Dispatch.nextAction('Tags', 'edit', tagId)
  }
      //For mobile style={{minWidth: '90%'}}>
  return (
      <div className='mw5 w-100 overflow-y-scroll bg-dark-gray pb3' style={{WebkitOverflowScrolling: 'touch'}}>
        { open ? 
        <div className='w-100 white'>
          {/* <div className='w-100 flex justify-between'>
            <div>
              </div>
              <div className='h3 bg-transparent'>
            </div>
          </div> */}
        <div className='w-100 flex flex-column'>
          <div className='ph3 pt3'>
            <input 
                className={'input-reset pv1 br2 pl2 w-100 bn bg-black white f5'}
                placeholder={'Search' }
                
                style={{outline: 'none'}}
                type='text'
            />
          </div>
          <div className='ph3 f5 near-white'>
            <div className='flex justify-between'>
              <div className='pt3 pb1'>People</div>
              <div 
                className='pt3 relative f4 pointer' 
                style={{top:2}}
                onClick={e => Dispatch.nextAction('Tags', 'edit', null)}>
                  <FontAwesomeIcon icon={faPlusCircle}/>
              </div>
            </div>
            <div className='flex flex-column' style={{alignItems: 'flex-start'}}>
            {
              Object.keys(peopleTags).map(key => 
              <div className=''><Tag {...props} data={{tag: tags[key], onEdit}}/></div>
              )
            }
            </div>
            <div className='flex justify-between'>
              <div className='pt3 pb1'>Types</div>
              {/* <div className='pt3 relative f4' style={{top:2}}><FontAwesomeIcon icon={faPlusCircle}/></div> */}
            </div>
              <div className='flex flex-column' style={{alignItems: 'flex-start'}}>
              {
                Object.keys(typeTags).map(key => 
                <div className=''><Tag {...props} data={{tag: tags[key], onEdit}}/></div>
                )
              }
              </div>
              <div className='flex justify-between'>
              <div className='pt3 pb1'>Status</div>
              {/* <div 
                className='pt3 relative f4 pointer' 
                style={{top:2}}
                onClick={e => Dispatch.nextAction('Tags', 'edit', null)}>
                  <FontAwesomeIcon icon={faPlusCircle}/>
              </div> */}
            </div>
            <div className='flex flex-column' style={{alignItems: 'flex-start'}}>
            {
              Object.keys(statusTags).map(key => 
              <div className=''><Tag {...props} data={{tag: tags[key], onEdit}}/></div>
              )
            }
            </div>
              <div className='flex justify-between'>
              <div className='pt3 pb1'>Other</div>
              {/* <div className='pt3 relative f4' style={{top:2}}><FontAwesomeIcon icon={faPlusCircle}/></div> */}
            </div>
              <div className='flex flex-column' style={{alignItems: 'flex-start'}}>
              {
                Object.keys(otherTags).map(key => 
                <div className=''><Tag {...props} data={{tag: tags[key], onEdit}}/></div>
                )
              }
              </div>
          </div>
          </div>
        </div>
        :
        null
        }
      </div>
  )
}